export const TBD = false;
export const FetchRequest = async (url ,method ,headers , body)=>{
    const response = await fetch(url , {method ,headers ,body});
    return response.json();
};